import { useFeatureFlagEnabled } from 'posthog-js/react';

/** PostHog-managed rollout gates. Targeting lives in PostHog; the app only reads. */
export const POSTHOG_FEATURE_FLAGS = {
  CAP_TABLE_CITATIONS_ONLY: 'cap-table-citations-only',
  // Seasonal Workboard decorations. On for everyone unless PostHog explicitly turns this flag off.
  WORKBOARD_HALLOWEEN: 'workboard-halloween',
} as const;

export type PostHogFeatureFlag = (typeof POSTHOG_FEATURE_FLAGS)[keyof typeof POSTHOG_FEATURE_FLAGS];

/**
 * Reads a PostHog feature flag as a strict boolean. Anything other than an
 * explicit `true` - flags still loading, PostHog never initialized - is off.
 */
export const usePostHogFeatureFlag = (flag: PostHogFeatureFlag): boolean => useFeatureFlagEnabled(flag) === true;

/**
 * On unless PostHog has explicitly disabled the flag. A missing flag and the
 * loading state stay on, so the feature reaches everyone until it is turned off.
 */
export const usePostHogFeatureFlagDefaultOn = (flag: PostHogFeatureFlag): boolean =>
  useFeatureFlagEnabled(flag) !== false;
